import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { UsersService } from "src/app/services/users.service";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrls: [],
})
export class MainLayoutComponent implements OnInit {
  constructor(private userServices:UsersService,private authServices:AuthService,private router:Router ) {}

  ngOnInit(): void {

    this.getUsersList();
  }
  getUsersList() {

    this.userServices.getAllUsers(0).subscribe({
        next: (res) => {
          if(res.response.status==200){

          }
          

        },
        error: (err: any) => {  
         
          if(err =="Unauthorized."){

            this.authServices.logout().subscribe(()=>{
 
              localStorage.removeItem("user");
        
              this.router.navigate(['authentication/signin'], {
                queryParams: {},
              });
        
              document.location.reload();
        
      
            });
        
         
        } },
    });
}
}
